<template>
  <div class="user-tools" @click.stop>
    <div
      class="user-tools__action"
      v-b-popover.hover.top="'Change Status'"
    >
      <el-switch
        v-model="localStatus"
        @change="onStatusChange"
      />
    </div>

    <div
      class="user-tools__action user-tools__action--danger"
      v-b-popover.hover.top="'Delete User'"
      @click.stop="onDelete"
    >
      <button class="user-tools__btn user-tools__btn--danger">
        <i class="ion ion-trash-outline"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserTableTools",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localStatus: false,
    };
  },
  created() {
    this.localStatus = this.user.is_active;
  },
  methods: {
    async onStatusChange() {
      const activating = this.localStatus;
      if (!activating && this.user.role?.id === 1) {
        this.localStatus = this.user.is_active;
        this.swal({ title: "Action not allowed", text: "GLT Admin users cannot be deactivated.", icon: "error" });
        return;
      }
      const confirmed = await this.swal({
        title: "Are you sure?",
        text: activating
          ? "This user will be activated."
          : "This user will be deactivated.",
        icon: "warning",
        buttons: ["Cancel", activating ? "Activate" : "Deactivate"],
        dangerMode: !activating,
      });
      if (confirmed) {
        this.$emit("toggleStatus", { id: this.user.id, status: this.localStatus });
      } else {
        this.localStatus = this.user.is_active;
      }
    },
    async onDelete() {
      if (this.user.role?.id === 1) {
        this.swal({ title: "Action not allowed", text: "GLT Admin users cannot be deleted.", icon: "error" });
        return;
      }
      const confirmed = await this.swal({
        title: "Are you sure?",
        text: "This user will be permanently deleted. This action cannot be undone.",
        icon: "warning",
        buttons: ["Cancel", "Delete"],
        dangerMode: true,
      });
      if (confirmed) {
        this.$emit("deleteUser", this.user.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-tools {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 6px;
    border-radius: 6px;
    cursor: pointer;
    transition: box-shadow 0.18s ease, transform 0.18s ease;
    font-size: 20px;

    &--danger {
      color: $color-primary-company;
    }
  }
}
</style>
